import { render, staticRenderFns } from "./AdminIzmjena.vue?vue&type=template&id=7bae5f85&scoped=true&"
import script from "./AdminIzmjena.vue?vue&type=script&lang=js&"
export * from "./AdminIzmjena.vue?vue&type=script&lang=js&"
import style0 from "./AdminIzmjena.vue?vue&type=style&index=0&id=7bae5f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae5f85",
  null
  
)

export default component.exports